import styled from "styled-components";

export const QAEnvironmentPopUpBlockerInformationTextBox = styled.p`
  display: block;
  width: 100%;
  height: 45px;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  ${({theme}) => theme.font.presets.body};
  color: ${({theme}) => theme.colors.textMiddleDark};
`;